import React, { useState } from 'react';
import AdminCRUD from '../../components/admin/AdminCRUD';
import I18nForm from '../../components/admin/I18nForm';

const ICONS = ['chart-line', 'shopping-cart', 'bullhorn', 'code', 'truck', 'star'];

const ServiceForm = ({ initialData, onSave, onCancel }) => {
  const d = initialData || {};
  const [form, setForm] = useState({
    title:       d.title       || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    description: d.description || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    features:    d.features    || { en: [], 'zh-CN': [], 'zh-TW': [], ja: [] },
    slug:        d.slug        || '',
    icon:        d.icon        || 'star',
    order:       d.order       || 0,
    isActive:    d.isActive !== false,
  });

  const setFeaturesLang = (lang, text) => {
    const arr = text.split('\n').map(s => s.trim()).filter(Boolean);
    setForm(f => ({ ...f, features: { ...f.features, [lang]: arr } }));
  };

  const LANGS = [
    { key: 'en', label: 'EN' }, { key: 'zh-CN', label: '简中' },
    { key: 'zh-TW', label: '繁中' }, { key: 'ja', label: '日本語' }
  ];
  const [featLang, setFeatLang] = useState('en');

  const inputStyle = { width: '100%', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px 10px', fontSize: '13px', color: '#334155', outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' };

  return (
    <form onSubmit={e => { e.preventDefault(); onSave(form); }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        <I18nForm label="Title" value={form.title} onChange={v => setForm(f => ({ ...f, title: v }))} />
        <div>
          <label style={labelStyle}>Slug</label>
          <input value={form.slug} onChange={e => setForm(f => ({ ...f, slug: e.target.value }))} required style={inputStyle} placeholder="market-intelligence" />
        </div>
      </div>

      <I18nForm label="Description" value={form.description} onChange={v => setForm(f => ({ ...f, description: v }))} multiline rows={3} />

      <div style={{ marginBottom: '14px' }}>
        <label style={labelStyle}>Features (one per line)</label>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '4px' }}>
          {LANGS.map(l => (
            <button key={l.key} type="button" onClick={() => setFeatLang(l.key)}
              style={{ padding: '4px 10px', fontSize: '11px', fontWeight: featLang === l.key ? 700 : 400, color: featLang === l.key ? '#3b82f6' : '#64748b', background: 'transparent', border: 'none', borderBottom: featLang === l.key ? '2px solid #3b82f6' : '2px solid transparent', cursor: 'pointer' }}>
              {l.label}
            </button>
          ))}
        </div>
        <textarea value={(form.features[featLang] || []).join('\n')} onChange={e => setFeaturesLang(featLang, e.target.value)} rows={4}
          style={{ width: '100%', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px 10px', fontSize: '13px', boxSizing: 'border-box' }} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '20px' }}>
        <div>
          <label style={labelStyle}>Icon</label>
          <select value={form.icon} onChange={e => setForm(f => ({ ...f, icon: e.target.value }))} style={{ ...inputStyle, background: '#fff' }}>
            {ICONS.map(i => <option key={i} value={i}>{i}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Order</label>
          <input type="number" value={form.order} onChange={e => setForm(f => ({ ...f, order: Number(e.target.value) }))} style={inputStyle} />
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '2px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#334155', cursor: 'pointer' }}>
            <input type="checkbox" checked={form.isActive} onChange={e => setForm(f => ({ ...f, isActive: e.target.checked }))} />
            Active
          </label>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button type="submit" style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>Save</button>
        <button type="button" onClick={onCancel} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', cursor: 'pointer' }}>Cancel</button>
      </div>
    </form>
  );
};

const COLUMNS = [
  { key: 'title', label: 'Title (EN)', render: item => item.title?.en || '' },
  { key: 'slug', label: 'Slug' },
  { key: 'icon', label: 'Icon' },
  { key: 'order', label: 'Order' },
  { key: 'isActive', label: 'Active', render: item => item.isActive ? '✅' : '❌' },
];

const AdminServices = () => (
  <AdminCRUD
    title="Services"
    apiPath="/api/admin/services"
    columns={COLUMNS}
    FormComponent={ServiceForm}
  />
);

export default AdminServices;
